import { PageModuleData, PageModuleStatus } from "entities/pages/types";
import { DrawerHookResult } from "shared/hooks/useDrawerState";

export type PageModuleRow = Pick<
  PageModuleData,
  "id" | "name" | "layout" | "status" | "type"
>;

export type ColumnsProps = {
  moduleDetailsDrawer: DrawerHookResult<PageModuleData>;
  handleStatus: (value: { status: PageModuleStatus; moduleId: string }) => void;
  onDeleteClick: (moduleData: PageModuleData) => void;
  onMoveClick: (moduleData: PageModuleData) => void;
  onDuplicateClick: (moduleData: PageModuleData) => void;
  readOnly: boolean;
};

export enum MoveOrDuplicateType {
  Move = "move",
  Duplicate = "duplicate",
}
